import { clearStorage, getToken } from './storage'

const INACTIVITY_TIMEOUT = 24 * 60 * 60 * 1000
const WARNING_TIMEOUT = 23 * 60 * 60 * 1000 + 55 * 60 * 1000

let timeoutId = null
let warningTimeoutId = null
let countdownInterval = null
let isTracking = false
let remainingSeconds = 0
let onWarningCallback = null

const activityEvents = ['mousemove', 'keydown', 'scroll', 'click', 'touchstart', 'touchmove']

const clearCountdown = () => {
  if (countdownInterval) {
    clearInterval(countdownInterval)
    countdownInterval = null
  }
}

const clearTimer = () => {
  if (timeoutId) {
    clearTimeout(timeoutId)
    timeoutId = null
  }
  if (warningTimeoutId) {
    clearTimeout(warningTimeoutId)
    warningTimeoutId = null
  }
}

const logout = () => {
  clearCountdown()
  clearStorage()
  stopInactivityTracking()
  const origin = window.location.origin
  window.location.href = `${origin}/sign-in?reason=session_expired`
}

const handleInactivityTimeout = () => {
  logout()
}

const handleWarningTimeout = () => {
  if (onWarningCallback) {
    onWarningCallback()
  }
}

const startCountdown = (seconds) => {
  clearCountdown()
  remainingSeconds = seconds

  countdownInterval = setInterval(() => {
    remainingSeconds--
  }, 1000)
}

const resetTimer = () => {
  clearTimer()
  clearCountdown()

  if (!getToken()) {
    stopInactivityTracking()
    return
  }

  const seconds = INACTIVITY_TIMEOUT / 1000
  startCountdown(seconds)
  
  warningTimeoutId = setTimeout(handleWarningTimeout, WARNING_TIMEOUT)
  timeoutId = setTimeout(handleInactivityTimeout, INACTIVITY_TIMEOUT)
}

const handleActivity = () => {
  if (!isTracking) return
  resetTimer()
}

const handleVisibilityChange = () => {
  if (!document.hidden) {
    resetTimer()
  }
}

export const startInactivityTracking = (warningCallback = null) => {
  onWarningCallback = warningCallback
  if (isTracking) return

  isTracking = true
  resetTimer()

  activityEvents.forEach(event => {
    document.addEventListener(event, handleActivity, { passive: true })
  })

  document.addEventListener('visibilitychange', handleVisibilityChange)
}

export const stopInactivityTracking = () => {
  if (!isTracking) return

  isTracking = false
  clearTimer()
  clearCountdown()

  activityEvents.forEach(event => {
    document.removeEventListener(event, handleActivity)
  })

  document.removeEventListener('visibilitychange', handleVisibilityChange)
}

export const resetInactivityTimer = () => {
  resetTimer()
}

export default {
  start: startInactivityTracking,
  stop: stopInactivityTracking,
  reset: resetInactivityTimer
}
